import { render, staticRenderFns } from "./ModalEdit.vue?vue&type=template&id=724e1a50&scoped=true"
import script from "./ModalEdit.vue?vue&type=script&lang=js"
export * from "./ModalEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724e1a50",
  null
  
)

export default component.exports